import React, { useRef } from 'react'
import { DI } from '../../../../Core';
import { Checkbox, InlineStack } from '@shopify/polaris';
import { DragIcon } from '../../../../Asests/svgIcon/icon';
import { useTranslation } from 'react-i18next';

const DraggableOnboarding = (props: any) => {
    const { t } = useTranslation();
    const dragItem = useRef<any>();
    const dragOverItem = useRef<any>();

    const dragStart = (e: any, position: any) => {
        dragItem.current = position;
    };

    const dragEnter = (e: any, position: any) => {
        dragOverItem.current = position;
    };

    const drop = (list: any, key: string) => {
        const copyListItems = [...list];
        const dragItemContent = copyListItems[dragItem.current];
        copyListItems.splice(dragItem.current, 1);
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;

        if (key && key !== '') {
            props.updateState('fulfillment_settings', key, "priority", copyListItems);
        }
    };

    const onChangeSwitcher = (e: boolean, val: any, type: string) => {
        props.updateState('fulfillment_settings', type, val, e);
    }
    return (
        <React.Fragment>
            {
                props?.fulfillment_settings?.[props?.type]?.priority?.map((val: any, idx: number) => {
                    return (
                        <div
                            ref={dragOverItem}
                            onDragStart={(e) => dragStart(e, idx)}
                            onDragEnter={(e) => dragEnter(e, idx)}
                            onDragEnd={() => drop(props?.fulfillment_settings?.[props?.type]?.priority, props?.type)}
                            key={val}
                            draggable
                        >
                            <InlineStack gap="200" wrap={false}>
                                <div className='Custom-Draggable--pointer'>
                                    <DragIcon />
                                </div>
                                <Checkbox
                                    id={val === "sku" ? `product_Switch_${props?.type}_SKU` : `product_Switch_${props?.type}_Barcode`}
                                    label={val === "sku" ? t("SKU") : t("Barcode")}
                                    checked={val === "sku" ? props?.fulfillment_settings?.[props?.type]?.sku : props?.fulfillment_settings?.[props?.type]?.barcode}
                                    onChange={(e: boolean) => onChangeSwitcher(e, val, props?.type)}
                                />
                            </InlineStack>
                        </div>
                    );
                })
            }
        </React.Fragment>
    );
}

export default DI(DraggableOnboarding)